import { render } from "./ProgramAnalytics.vue?vue&type=template&id=675ac2cd&scoped=true"
import script from "./ProgramAnalytics.vue?vue&type=script&lang=js"
export * from "./ProgramAnalytics.vue?vue&type=script&lang=js"

import "./ProgramAnalytics.vue?vue&type=style&index=0&id=675ac2cd&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675ac2cd"],['__file',"resources/js/components/ProgramAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "675ac2cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('675ac2cd', __exports__)) {
    api.reload('675ac2cd', __exports__)
  }
  
  module.hot.accept("./ProgramAnalytics.vue?vue&type=template&id=675ac2cd&scoped=true", () => {
    api.rerender('675ac2cd', render)
  })

}


export default __exports__